export default __webpack_public_path__ + "static/media/EM0999.34I-41721_-25024_0.dd2cc71a.jpg";